<section class="__left-align-group">
  <awair-floor-icon class="__floor-button"
                    [color]="'#FFFFFF'"
                    [class.__floor-button--active]="hasFloor"
                    [class.__floor-button--selected]="isSidebarOpened"
                    (click)="onToggleSidebar(hasFloor)">
  </awair-floor-icon>
  <div class="__divider-right"></div>
  <h3 class="__floor-name">{{floorName}}</h3>
</section>

<section class="__right-align-group">
  <awair-air-component-picker class="__component-picker"
                              [selectedAirComponent]="selectedAirComponent"
                              [isDisabled]="!hasFloor"
                              (selectAirComponent)="onSelectAirComponent($event)">
  </awair-air-component-picker>
  <div class="__divider-left"></div>
  <awair-cog-icon class="__editor-button"
                  (click)="onOpenEditor()">
  </awair-cog-icon>
</section>
